<template>
	<div class="file-content">
		<div class="header">
			<div class="title">{{ dataSource.name || "" }}</div>
			<btn-collect :dataSource="dataSource"></btn-collect>
		</div>
		<div style="height: 100%; overflow-y: auto">
			<el-empty description="请选择资源文件" v-if="dataSource.subcount > 0 || dataSource.subcount === undefined"></el-empty>
			<img v-if="oneImg.show" :src="oneImg.src" style="width: 100%" />
			<div v-if="showPdfImg">
				<img v-lazy="url" v-for="(url, index) in pdfImgs" :key="index" style="width: 100%" />
			</div>
			<file-pdf :src="onePdf.src" v-if="onePdf.show"></file-pdf>
			<file-video :src="oneVideo.src" v-if="oneVideo.show"></file-video>
			<file-download v-if="fileDown" :downloadPath="dataSource.filepath" :title="dataSource.name" :downloadFilekey="dataSource.id"></file-download>
		</div>
	</div>
</template>

<script>
import { StandardService } from "@/service";
import { ApiService, DomainService } from "@/libs";

import FileDownload from "./file-download";
import FileVideo from "./file-video";
import FileContent from "./file-content";
import FilePdf from "./file-pdf";
import BtnCollect from "./btn-collect.vue";

export default {
	inject: ['handleLoading'],
	props: {
		dataSource: { default: () => ({}) },
	},
	data() {
		return {
			// loading: false,
			pdfImgs: [],
		};
	},
	watch: {
		"dataSource.id": function (id) {
			id && this.GetStandardView();
		},
	},
	components: { FileDownload, FileVideo, FileContent, BtnCollect, FilePdf },
	computed: {
		oneImg() {
			const filepath = this.dataSource.filepath || "";
			return {
				src: `${ApiService.StdApi}/std/${filepath}`,
				show: [".jpg", ".png", ".gif", ".jpeg"].some((suffix) => filepath.toLowerCase().endsWith(suffix)),
			};
		},
		oneVideo() {
			const filepath = this.dataSource.filepath || "";
			return {
				src: `${ApiService.StdApi}/${filepath.includes('std/') ? filepath : 'std/' + filepath}`,
				show: [".webm",".mp4"].some((suffix) => filepath.toLowerCase().endsWith(suffix)),
			};
		},
		onePdf() {
			const filepath = this.dataSource.filepath || "";
			return {
				src: `${ApiService.StdApi}/std/${filepath}`,
				show: filepath.startsWith("UP/"),
			};
		},
		showPdfImg() {
			const filepath = this.dataSource.filepath || "";
			const subcount = this.dataSource.subcount || 0;
			if (filepath.startsWith("ZL/") || filepath.startsWith("UP/")) return false;
			return [".pdf"].some((suffix) => filepath.toLowerCase().endsWith(suffix)) && subcount === 0;
		},
		fileDown() {
			const filepath = this.dataSource.filepath || "";

			if (filepath.startsWith("UP/")) return false;
			
			return filepath.startsWith("ZL/");
		},
	},
	methods: {
		// pdf文件获取图片地址
		async GetStandardView() {
			if (!this.showPdfImg) return false;
			this.pdfImgs = [];
			this.handleLoading(true)
			try{
				const { images, prefix } = await StandardService.GetStandardView({ src: this.dataSource.filepath });
			// this.loading = false;
			this.handleLoading(false);
			this.pdfImgs = images.map((url) => `${ApiService.StdApi}/${prefix.includes('std/') ? prefix : 'std/' + prefix}${url}`);
			}catch(err) {
				this.handleLoading(false);
			}
			
		},
	},
};
</script>

<style scoped lang="less">
.file-content {
	width: 100%;
	height: 100%;
	position: relative;
	padding-top: 40px;
	.header {
		position: absolute;
		top: 0;
		width: 100%;
		left: 0;
		z-index: 99;
		font-size: 14px;
		font-weight: 500;
		color: #2f3848;
		height: 40px;
		padding: 0 14px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #d6d6d6;
		background-color: #fff;
		.title {
		}
		.search-input {
			width: 240px;
			border-radius: 15px;
			/deep/ input {
				border-radius: 15px;
			}
		}
	}
	.download {
		padding: 20px;
		text-align: center;
		.download-btn {
			min-width: 100px;
		}
	}
}
</style>
